const HANGUL_SYLLABLE_START = 0xac00;
const HANGUL_SYLLABLE_END = 0xd7a3;
const FINAL_CONSONANT_COUNT = 28;
const FINAL_CONSONANT_RIEUL = 8;

export const appendRoParticle = (word: string) => {
  const lastCode = word.charCodeAt(word.length - 1);

  if (lastCode < HANGUL_SYLLABLE_START || lastCode > HANGUL_SYLLABLE_END) {
    return `${word}로`;
  }

  const finalConsonant =
    (lastCode - HANGUL_SYLLABLE_START) % FINAL_CONSONANT_COUNT;

  if (finalConsonant === 0 || finalConsonant === FINAL_CONSONANT_RIEUL) {
    return `${word}로`;
  }

  return `${word}으로`;
};

export const appendTopicParticle = (word: string) => {
  const lastCode = word.charCodeAt(word.length - 1);

  if (lastCode < HANGUL_SYLLABLE_START || lastCode > HANGUL_SYLLABLE_END) {
    return `${word}은`;
  }

  const hasFinalConsonant =
    (lastCode - HANGUL_SYLLABLE_START) % FINAL_CONSONANT_COUNT !== 0;

  return `${word}${hasFinalConsonant ? '은' : '는'}`;
};
